import React, { FC } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

// constants
import routes from '../../constants/routes';

import CreateCustomerLazy from './CreateCustomer.lazy';

// components

const AampeAdminMain: FC<React.PropsWithChildren<unknown>> = () => {
    return (
        <Switch>
            <Route
                path={routes.aampeAdminCreateCustomer}
                component={CreateCustomerLazy}
            />

            <Redirect to={routes.aampeAdminCreateCustomer} />
        </Switch>
    );
};

export default AampeAdminMain;
